import { HOLD_CAMPAIGN_STATUS } from "@/constants/hold";
import { HoldCampaignWithStatus } from "@/types/holdCampaigns";

// Status order for sorting - live and future first, then old ones
const holdStatusOrder: Record<string, number> = {
  [HOLD_CAMPAIGN_STATUS.LIVE]: 0,
  [HOLD_CAMPAIGN_STATUS.FUTURE]: 1,
  [HOLD_CAMPAIGN_STATUS.PAUSED]: 2,
  [HOLD_CAMPAIGN_STATUS.PAST]: 3,
};

/**
 * Sort hold campaigns with live and future campaigns first, then old ones
 */
export const sortHoldCampaignsByStatus = (campaigns: HoldCampaignWithStatus[]): HoldCampaignWithStatus[] => {
  return [...campaigns].sort((a, b) => {
    const aStatusOrder = holdStatusOrder[a.status] ?? 999;
    const bStatusOrder = holdStatusOrder[b.status] ?? 999;

    // Primary sort by status priority
    if (aStatusOrder !== bStatusOrder) {
      return aStatusOrder - bStatusOrder;
    }

    // Secondary sort by campaign name for campaigns of the same status
    return (a.name || "").localeCompare(b.name || "");
  });
};
